import { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';
import nhost from '../nhost';
import { avg } from '../helpers';

const TYPE = {
  'Rött':        { dot: '#8B2A3E', bg: '#F5E8EB', fg: '#5C1A28' },
  'Vitt':        { dot: '#A07830', bg: '#F7F0E6', fg: '#7D5A22' },
  'Rosé':        { dot: '#C4566A', bg: '#FCE8EF', fg: '#A03060' },
  'Mousserande': { dot: '#356BB3', bg: '#E8F0FC', fg: '#234E8C' },
};

const WINE_QUERY = `
  query($id: uuid!) {
    wines_by_pk(id: $id) {
      id name grape type country region vintage
      ratings { rating }
      profileByCreatedBy { display_name }
    }
  }
`;

export default function NewWinePopup({ wineId, onClose, onWineClick }) {
  const [wine, setWine] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    nhost.graphql.request(WINE_QUERY, { id: wineId }).then(({ data }) => {
      if (data?.wines_by_pk) setWine(data.wines_by_pk);
      else setNotFound(true);
    });
  }, [wineId]);

  if (notFound) return null;
  if (!wine) return null;

  const tm = TYPE[wine.type] || { dot: '#8B2A3E', bg: '#F5E8EB', fg: '#5C1A28' };
  const ratingNum = parseFloat(avg(wine.ratings)) || 0;
  const addedBy = wine.profileByCreatedBy?.display_name;

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        <div style={{ textAlign: 'center', fontSize: 13, fontWeight: 600, color: 'var(--wine)', marginBottom: 14 }}>
          🍷 Nytt vin tillagt
        </div>

        <div style={{ background: tm.bg, borderRadius: 18, padding: 15, border: '1px solid rgba(60,20,30,.08)' }}>
          <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
            <div style={{
              flexShrink: 0, width: 58, height: 58, borderRadius: '50%',
              background: '#fff', border: `2px solid ${tm.dot}`,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            }}>
              {ratingNum > 0 ? (
                <>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: 21, fontWeight: 700, color: tm.fg, lineHeight: .9 }}>{avg(wine.ratings)}</div>
                  <div style={{ fontSize: 7.5, letterSpacing: 1, textTransform: 'uppercase', color: 'var(--muted)', marginTop: 2 }}>av 5</div>
                </>
              ) : (
                <div style={{ fontSize: 9, letterSpacing: .5, textTransform: 'uppercase', color: 'var(--muted)', textAlign: 'center', lineHeight: 1.3 }}>Ej<br />betyg</div>
              )}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 19, fontWeight: 600, lineHeight: 1.12, color: 'var(--ink)' }}>{wine.name}</div>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 3 }}>{wine.grape}{wine.vintage ? ` · ${wine.vintage}` : ''}</div>
              {(wine.region || wine.country) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11.5, color: 'var(--muted)', marginTop: 3 }}>
                  <MapPin size={12} strokeWidth={1.9} />
                  {[wine.region, wine.country].filter(Boolean).join(', ')}
                </div>
              )}
            </div>
          </div>
        </div>

        {addedBy && (
          <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--muted)', marginTop: 10 }}>
            Tillagt av <strong style={{ color: 'var(--ink)' }}>{addedBy}</strong>
          </div>
        )}

        <div className="btn-row" style={{ marginTop: 16 }}>
          <button className="btn-secondary" onClick={onClose}>Stäng</button>
          <button className="btn-primary" onClick={() => { onWineClick({ id: wine.id }); onClose(); }}>Visa vin</button>
        </div>
      </div>
    </div>
  );
}
